module.exports = __webpack_public_path__ + "static/img/b8.6d73a32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b8.jpg
// module id = ysAY
// module chunks = 1